export default "__VITE_ASSET__BjLp8IAs__"